import React from 'react';
import ProductCarousel from './ProductCarousel';
import DownloadCarousel from './DownloadCarousel';
import ArticleCarousel from './ArticleCarousel';
import TabsProductCarousel from './TabsProductCarousel';
import InPageCarouselWrapper from './InPageCarouselWrapper';
import YoutubeCardContainer from './YoutubeCardContainer';
import PillarCarousel from './PillarCarousel';

const Carousel = ({ carouselContent }) => {
    if (!carouselContent)
        return '';

    if (carouselContent.__typename === 'Contentstack_product_carousel')
        return (<ProductCarousel productCarouselContent={carouselContent} />);

    if (carouselContent.__typename === 'Contentstack_download_carousel')
        return (<DownloadCarousel downloadCarouselContent={carouselContent} />);

    if (carouselContent.__typename === 'Contentstack_carousel_article')
        return (<ArticleCarousel articleCarouselContent={carouselContent} />);

    if (carouselContent.__typename === 'Contentstack_tabs_carousel_product')
        return (<TabsProductCarousel tabsProductCarouselContent={carouselContent} />);

    if (carouselContent.__typename === 'Contentstack_in_page_carousel_wrapper')
        return (<InPageCarouselWrapper inPageCarouselContent={carouselContent} />);

    if (carouselContent.__typename === 'Contentstack_youtube_carousel_container')
        return (<YoutubeCardContainer youtubeCardContainerContent={carouselContent} />);
    
    if (carouselContent.__typename === 'Contentstack_pillar_carousel'){
        return (<PillarCarousel pillarCarouselContent={carouselContent} />);
    }

    return '';
}

export default Carousel;
